export default {
    apiGateway: {
        REGION: 'us-east-1',
        URL: 'https://jguz7puem3.execute-api.us-east-1.amazonaws.com/dev'
    },
    jesseTailNumber: 'N76616'
}